export const answersDataHv = [
    { value: 100, html: 'Sempre', id: 1 },
    { value: 75, html: 'Quase Sempre', id: 2 },
    { value: 25, html: 'Quase Nunca', id: 3 },
    { value: 0, html: 'Nunca', id: 4 },
    { value: -1, html: 'Não Foi Possível Verificar', id: 5 },
  ];